module.exports = __webpack_public_path__ + "img/LocumCredits.924012da.jpg";